interface ErrorContext {
  userId?: string;
  path?: string;
  timestamp?: number;
  [key: string]: any;
}

export function logError(error: Error, context: ErrorContext = {}) {
  const errorLog = {
    message: error.message,
    stack: error.stack,
    ...context,
    timestamp: context.timestamp || Date.now(),
    path: context.path || window.location.pathname,
  };

  // Log to console in development
  if (import.meta.env.DEV) {
    console.error('Error:', errorLog);
  }

  // Send to error tracking service
  // Example using a hypothetical error tracking service
  try {
    fetch('/api/log-error', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(errorLog),
    });
  } catch (e) {
    // Fallback logging if error service fails
    console.error('Failed to log error:', e);
  }
}